import React, { useRef } from "react";
import { InputGroup, Button, Form } from "react-bootstrap";
import { useTranslation } from "../../hooks/useTranslation";

/**
 * Generic search bar for tables in My Account section. 
 * Filters the provided data list by the search term, using a recursive search function 
 * that checks all string/number/boolean values in the data objects (including nested ones).
 * @param {*} dataList **full list** of data to filter (e.g. orders, greetings, workers)
 * @param {*} setFilteredDataList setter function for the filtered list (e.g. setFilteredOrders)
 * @param {*} onPageReset **optional** callback to reset pagination to page 1 when a new search is performed
 * @returns 
 */
function TableSearchBar ({dataList, setFilteredDataList, onPageReset}) {
    const { t } = useTranslation();
  const inputRef = useRef(null);

  const containsSearch = (value, search) => { 
      if (value == null) return false;

      // string / number / boolean
      if ( typeof value === "string" || typeof value === "number" || typeof value === "boolean" ) {
        return value.toString().trim().toLowerCase().includes(search);
      }

      // array
      if (Array.isArray(value)) {
        return value.some(item => containsSearch(item, search));
      }

      // object
      if (typeof value === "object") {
        return Object.values(value).some(v =>
          containsSearch(v, search)
        );
      }

      return false; 
    };

  const handleSearch = () => {
    onPageReset?.();
    const term = inputRef.current.value.toLowerCase();
    setFilteredDataList(dataList.filter(item => containsSearch(item, term)));
  };

  return (
    <InputGroup className="searchbar-table" style={{ direction: "ltr" }}>
      <Button variant="outline-secondary" onClick={handleSearch} aria-label={t("SearchPlaceholder")} className="search-btn">
        <img src="../images/search-icon.svg" alt="" />
      </Button>
      <Form.Control ref={inputRef} className="border-0" aria-label={t("SearchPlaceholder")}
        style={{ direction: "rtl" }} placeholder={t("SearchPlaceholder")} onChange={handleSearch} />
    </InputGroup>
  );
}

export default TableSearchBar;